import './modules/accordion.js';
import './modules/accordionLineAnimation.js';
import './modules/pageOffset.js';
import './modules/header.js';
import './modules/carousel.js';
import './modules/searchField.js';
import './modules/sectionAnimation.js';
import {getHeaderHeight} from "./utils/functions";

// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
let vh = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${vh}px`);

// We listen to the resize event
window.addEventListener('resize', () => {
  // We execute the same script as before
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', `${vh}px`);
});

const screen = {
  width: window.innerWidth,
  height: window.innerHeight
};

let aboutCollapse = document.getElementById('aboutCollapseArea');
let aboutCollapseButton = document.querySelector('[data-bs-target="#aboutCollapseArea"]');
if (aboutCollapse && aboutCollapseButton) {
    if (aboutCollapse && screen.height < 768 && (screen.height > screen.width)) {
        aboutCollapseButton.innerText = ((typeof _translations !== "undefined") ? _translations.show_less : false) ?? 'Show less';
        aboutCollapseButton.setAttribute('aria-expanded', true);
        aboutCollapse.classList.add('show');
    } else {
        aboutCollapseButton.innerText = ((typeof _translations !== "undefined") ? _translations.show_more : false) ?? 'Show more';
        aboutCollapseButton.setAttribute('aria-expanded', false);
        aboutCollapse.classList.remove('show');
    }
}

if (aboutCollapseButton) {
    aboutCollapseButton.addEventListener('click', (evt) => {
        if (!evt.target.classList.contains('collapsed')) {
            aboutCollapseButton.innerText = ((typeof _translations !== "undefined") ? _translations.show_less : false) ?? 'Show less';
            aboutCollapseButton.setAttribute('aria-expanded', true);
        } else {
            aboutCollapseButton.innerText = ((typeof _translations !== "undefined") ? _translations.show_more : false) ?? 'Show more';
            aboutCollapseButton.setAttribute('aria-expanded', false);
        }
    });
}


let collapse = document.querySelectorAll('[data-bs-toggle="collapse"]');
if (collapse) {
    collapse.forEach((el) => {

        console.debug(el);

        if (el.dataset['bs-target']) {
            let related = document.querySelector(el.dataset['bs-target']);
            if (related) {
                related.addEventListener('show.bs.collapse', (e) => {
                    console.debug(e);
                    let label = el.dataset['label-expanded'];
                    if (label) {
                        el.innerText = label;
                    }
                });

                related.addEventListener('hide.bs.collapse', (e) => {
                    console.debug(e);
                    let label = el.dataset['label-collapsed'];
                    if (label) {
                        el.innerText = label;
                    }
                });
            }
        }
    });
}